export const ITEMS_PER_PAGE = 10;
export const MAX_ITEMS = 10;
export const TOTAL_PAGE_ITEMS = MAX_ITEMS - 2; // 2 ellipsis
export const ELLIPSIS = '...';
